import { AlertMessageService } from '@serpro/ngx-suite-rfb';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { CacheDominios, FiltroPesquisa, Painel2PesquisaComponent } from "../painel2-pesquisa/painel2-pesquisa.component";
import { Painel4CadastroComponent } from "../painel4-cadastro/painel4-cadastro.component";
import { Lud, TipoLud } from "src/app/shared/model/lud.model";
import { Recurso } from "src/app/shared/model/recurso.model";
import { BancoRecursos } from "src/app/shared/util/banco-recursos.util";
import { TipoAtoService } from "src/app/shared/services/tipo-ato.service";
import { OrgaoService } from "src/app/shared/services/orgao.service";

@Component({
    selector: 'app-painel-luds',
    templateUrl: './painel-luds.component.html',
    styleUrls: ['./painel-luds.component.css', '../../../../../src/app/shared/css/contraste.css']
})
export class PainelLUDsComponent implements OnInit, OnChanges {

    @Input() ludSelecionado: Lud | null;
    @Input() bancoRecursos: BancoRecursos;
    @Input() isGerirRecursos: boolean;
    @Output() ludConfirmado = new EventEmitter<Lud | null>();
    @Output() fechar = new EventEmitter<string | null>();
    @ViewChild(Painel2PesquisaComponent) painel2?: Painel2PesquisaComponent;
    @ViewChild(Painel4CadastroComponent) painel4?: Painel4CadastroComponent;

    url: string;
    fragmento: string;
    dispositivo: string;
    linkInternoNormas = false;

    cacheDominios: CacheDominios;
    filtroPesquisa: FiltroPesquisa;
    filtroPesquisaNormas: FiltroPesquisa = new FiltroPesquisa();
    filtroPesquisaInternet: FiltroPesquisa = new FiltroPesquisa();
    filtroPesquisaLUDsConfeccionados: FiltroPesquisa = new FiltroPesquisa();
    recursosNormas: Recurso[] = [];
    recursosInternet: Recurso[] = [];
    recursos: Recurso[] = [];

    exibirPesquisa = false;
    exibirResultado = false;
    exibirCadastro = false;

    constructor(
        private tipoAtoService: TipoAtoService,
        private orgaoService: OrgaoService,
        private alertMessageService: AlertMessageService
    ) {}

    ngOnInit(): void {
        this.cacheDominios = new CacheDominios();
        this.carregarOrgaos();
        this.carregarTiposAto();
        this.filtroPesquisa = this.filtroPesquisaNormas;
        this.filtroPesquisaNormas.tipoPesquisa = 1;
        this.filtroPesquisaInternet.tipoPesquisa = 2;
        this.filtroPesquisaLUDsConfeccionados.tipoPesquisa = 3;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['ludSelecionado']) {
            this.filtroPesquisa = this.filtroPesquisaNormas;
            const novo = changes['ludSelecionado'].currentValue;
            if (changes['ludSelecionado'] && this.painel2) {
                this.painel2.limparFiltroPesquisa();
                this.filtroPesquisaInternet.limpar();
                this.filtroPesquisaNormas.limpar();
                this.filtroPesquisaLUDsConfeccionados.limpar();
                this.filtroPesquisa.limpar();
            }
            if (novo && novo.url) {
                const lud = Lud.criarLudDoUrl(novo.url);
                let recurso: Recurso | null = null;
                if (lud.idAto) {
                    const atoRecurso = this.bancoRecursos.obterAtoRecursoNormas(lud.idAto);
                    if (atoRecurso && atoRecurso.recurso) {
                        recurso = atoRecurso.recurso;
                    }
                } else {
                    recurso = this.bancoRecursos.obterRecursoInternet(novo.url);
                    if (recurso) {
                        lud.tipo = TipoLud.LUD_INTERNET
                    }
                }
                if (recurso) {
                    this.recursos = [recurso];
                    const fragmento = recurso.fragmentos.find(f => f.fragmento == lud.fragmento);
                    lud.dispositivo = fragmento ? fragmento.dispositivo : '';
                    this.exibirResultado = true;
                } else {
                    this.exibirResultado = false
                }
                this.exibirPesquisa = false;
                this.exibirCadastro = false;
                novo.tipo = lud.tipo;
                novo.idAto = lud.idAto;
                novo.url = lud.url;
                novo.fragmento = lud.fragmento;
                novo.dispositivo = lud.dispositivo;
            } else {
                if (novo) {
                    novo.url = '';
                    novo.fragmento = '';
                    novo.dispositivo = '';
                }
                this.recursos = [];
                this.exibirPesquisa = false;
                this.exibirResultado = false;
                this.exibirCadastro = false;
            }
        }
    }

    private carregarTiposAto() {
        this.tipoAtoService.getTodos().subscribe({
            next: retorno => {
                retorno.sort((a, b) => a.nomeTipoAto > b.nomeTipoAto ? 1 : -1);
                this.cacheDominios.tiposAto = retorno;
                this.cacheDominios.labelsTipoAto = this.cacheDominios.tiposAto.map(o => o.nomeTipoAto);
            },
            error: () => null
        });
    }

    private carregarOrgaos() {
        this.orgaoService.getAtivos().subscribe({
            next: retorno => {
                retorno.sort((a, b) => a.siglaOrgao > b.siglaOrgao ? 1 : -1);
                this.cacheDominios.orgaos = retorno;
                this.cacheDominios.labelsOrgao = this.cacheDominios.orgaos.map(o => o.siglaOrgao + ' - ' + o.nomeOrgao);
            },
            error: () => null
        });
    }

    selecionarTipoPesquisa(i: number) {
        if (this.filtroPesquisa.tipoPesquisa === i) {
            if (i === this.filtroPesquisaLUDsConfeccionados.tipoPesquisa) {
                this.exibirResultado = !this.exibirResultado
            } else {
                this.exibirPesquisa = !this.exibirPesquisa;
            }
        } else if (i === 1) {
            this.filtroPesquisa = this.filtroPesquisaNormas;
            this.recursos = this.recursosNormas;
            this.exibirResultado = false;
            this.exibirPesquisa = true;
        } else if (i === 2) {
            this.filtroPesquisa = this.filtroPesquisaInternet;
            this.recursos = this.recursosInternet;
            this.exibirResultado = false;
            this.exibirPesquisa = true;
        } else if (i === 3) {
            this.filtroPesquisa = this.filtroPesquisaLUDsConfeccionados;
            this.exibirPesquisa = false;
            this.exibirResultado = true;
        }
    }


    incluirLUDInternet(event: MouseEvent) {
        this.painel4?.incluirNovoRecursoInternet();
        this.exibirCadastro = true;
        this.alertMessageService.dismissAll();
        event.stopPropagation();
    }

    selecionarDispositivo(lud: Lud) {
        this.ludSelecionado = lud;
        this.ludConfirmado.emit(lud);
    }
    
    publicarResultado(recursos: Recurso[]) {
        if (this.filtroPesquisa.tipoPesquisa === 1) {
            this.recursosNormas = recursos;
        } else if (this.filtroPesquisa.tipoPesquisa === 2) {
            this.recursosInternet = recursos;
        } else {
            this.recursosNormas = [];
            this.recursosInternet = [];
        }
        this.recursos = recursos;
        this.exibirResultado = true;
        if (recursos.length > 0) {
            this.exibirPesquisa = false;
        }
    }

    selecionarRecurso(recurso: Recurso) {
        if (recurso.idRecurso) {
            this.painel4?.abrirRecurso(recurso.idRecurso);
        } else {
            this.painel4?.incluirNovoRecursoNormas(recurso);
        }
        this.exibirResultado = false;
        this.exibirCadastro = true;
        this.alertMessageService.dismissAll();
    }

    atualizarRecursoSelecionado(recurso: Recurso | null) {
        if (recurso == null) {
            this.recursos = [];
            this.exibirResultado = false;
            this.exibirCadastro = false;
        } else {
            this.recursos = [recurso];
            if (this.filtroPesquisa.tipoPesquisa === this.filtroPesquisaNormas.tipoPesquisa) {
                this.recursosNormas = this.recursos;
            } else if (this.filtroPesquisa.tipoPesquisa === this.filtroPesquisaInternet.tipoPesquisa) {
                this.recursosInternet = this.recursos;
            }
            this.exibirResultado = true;
            this.exibirCadastro = false;
        }
    }
}
